/**
 * Parse a single checklist / screener clause like "industry = Medical Distribution".
 * Finds the leftmost comparison operator, preferring multi-char ops (<=, >=, etc.).
 */
const OPERATORS_DESC = ["<=", ">=", "!=", "==", "<", ">", "="] as const;

export type ChecklistClause = {
  field: string;
  operator: string;
  value: string;
};

export function parseChecklistClause(query: string): ChecklistClause | null {
  const s = query?.trim();
  if (!s) return null;

  let opIndex = -1;
  let op = "";

  outer: for (let i = 0; i < s.length; i++) {
    for (const candidate of OPERATORS_DESC) {
      if (s.slice(i, i + candidate.length) === candidate) {
        opIndex = i;
        op = candidate;
        break outer;
      }
    }
  }

  if (opIndex < 0 || !op) return null;

  const field = s.slice(0, opIndex).trim();
  const value = s.slice(opIndex + op.length).trim();
  if (!field || value === undefined) return null;

  return { field, operator: op, value };
}

/**
 * Flatten stored checklist query strings into [field, operator, value, ...] for CompanyScreenerService.
 */
export function checklistQueriesToScreenerTokens(queries: string[]): string[] {
  const out: string[] = [];
  for (const q of queries) {
    const parsed = parseChecklistClause(q);
    if (parsed) {
      out.push(parsed.field, parsed.operator, parsed.value);
    }
  }
  return out;
}
